import { Typography } from '@yiluhub/ui-elements';
import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import clsx from 'clsx';
import React, { useState } from 'react';

import CardLink from './cardLink';
import './styles.scss';

export type CardProps = {
  heading: string;
  subHeading: string;
  price: string;
  image: string;
  linkUrl: string;
  handleClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  className?: string;
  /**
   * Field to identify the components in the test
   */
  dataTestId: string;
  MaMLogo?: boolean;
};

const Card: React.FC<CardProps> = ({
  heading,
  subHeading,
  price,
  image,
  linkUrl,
  handleClick,
  className = '',
  dataTestId,
  MaMLogo,
}) => {
  const [focused, setFocused] = useState(false);
  return (
    <div className={clsx(className, 'cardContainer')}>
      <CardLink
        linkUrl={linkUrl}
        dataTestId={dataTestId}
        handleClick={handleClick}
        focused={focused}
        setFocus={setFocused}
      >
        <div className="outerBox">
          <div
            data-testid={`${dataTestId}-bg-image`}
            className="imageContainer"
            style={{
              backgroundImage: `url(${image})`,
            }}
          />
          {MaMLogo && (
            <div className="floatingLogoContainer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="10"
                viewBox="0 0 76 10"
                fill="none"
              >
                <path
                  d="M72.4745 4.03462C71.7579 4.03462 71.2693 4.4306 71.1281 5.34026H73.7339C73.6905 4.4734 73.2454 4.03462 72.4745 4.03462ZM72.5288 2.52565C74.8306 2.52565 76.1118 4.02392 75.9923 6.64589H71.1281C71.1607 7.60907 71.6927 8.17627 72.5396 8.17627C73.1368 8.17627 73.5819 7.90872 73.7991 7.39503H75.8946C75.5363 8.87189 74.266 9.66384 72.5505 9.66384C70.2704 9.66384 68.8697 8.27259 68.8697 6.1215C68.8697 3.92761 70.3029 2.52565 72.5288 2.52565ZM37.3501 7.86591C36.5793 7.86591 36.0038 7.50205 36.0038 6.82783C36.0038 6.34624 36.297 5.99308 36.9593 5.59711L38.5445 7.43784C38.1645 7.72679 37.7953 7.86591 37.3501 7.86591ZM37.7193 1.60529C38.1536 1.60529 38.5553 1.85143 38.5553 2.35442C38.5553 2.73969 38.3165 3.02864 37.6542 3.45672C37.1764 2.96443 36.9267 2.67548 36.9267 2.30091C36.9267 1.89424 37.2416 1.60529 37.7193 1.60529ZM43.0612 9.4819L41.1829 7.39503C41.8018 6.63519 42.2143 5.74693 42.3555 4.69814H40.4228C40.3143 5.19043 40.1623 5.63991 39.9342 6.01448L38.7616 4.71955C39.8257 4.07743 40.3794 3.39251 40.3794 2.39723C40.3794 0.973875 39.2285 0 37.7084 0C36.1558 0 34.9398 1.01668 34.9398 2.31162C34.9398 3.01794 35.3089 3.55304 35.8518 4.17375C34.5055 4.83727 33.8431 5.73623 33.8431 6.87063C33.8431 8.51873 35.2438 9.66384 37.1113 9.66384C38.045 9.66384 38.8811 9.37488 39.6845 8.75417L40.3143 9.4819H43.0612ZM52.2033 0.181933L50.5638 6.02518H50.5421L48.9243 0.181933H45.287V9.49261H47.5997V3.17847H47.6214L49.6192 9.49261H51.4976L53.4737 3.17847H53.4954V9.49261H55.8081V0.181933H52.2033ZM14.5709 9.4819V0.171231H16.8184V9.4819H14.5709ZM11.4439 9.4819V2.70759H13.6914V9.4819H11.4439ZM6.91629 0.171231H10.5319V9.4819H8.2192V3.15707H8.18663L6.2214 9.4819H4.34304L2.34524 3.15707H2.31267V9.4819H0V0.171231H3.6373L5.25508 5.99308H5.27679L6.91629 0.171231ZM11.4439 1.85143V0.171231H13.6914V1.85143H11.4439ZM21.0529 4.03462C20.3363 4.03462 19.8477 4.4306 19.7065 5.34026H22.3124C22.2689 4.4734 21.8129 4.03462 21.0529 4.03462ZM21.0963 2.52565C23.3981 2.52565 24.6793 4.02392 24.5599 6.64589H19.6957C19.7174 7.60907 20.2603 8.17627 21.1072 8.17627C21.7043 8.17627 22.1495 7.90872 22.3667 7.39503H24.4622C24.1039 8.87189 22.8335 9.66384 21.118 9.66384C18.8379 9.66384 17.4373 8.27259 17.4373 6.1215C17.4373 3.92761 18.8814 2.52565 21.0963 2.52565ZM29.1961 5.31886C30.651 5.60781 31.4762 6.08939 31.4762 7.27731C31.4762 8.72207 30.2601 9.66384 28.132 9.66384C26.1234 9.66384 24.9725 8.81838 24.929 7.39503H27.0897C27.0897 7.87661 27.5783 8.24048 28.2298 8.24048C28.8161 8.24048 29.2504 7.95153 29.2504 7.46994C29.2504 7.07397 28.9572 6.94555 27.9257 6.79572C26.7097 6.61379 25.0702 6.34624 25.0702 4.65534C25.0702 2.93233 26.764 2.52565 28.1538 2.52565C30.1407 2.52565 31.2047 3.3497 31.2373 4.63393H29.1744C29.1744 4.20586 28.8486 3.97041 28.1538 3.97041C27.6109 3.97041 27.3069 4.10954 27.3069 4.48411C27.296 5.10482 28.132 5.11552 29.1961 5.31886ZM60.0642 7.95153C61.0197 7.95153 61.454 7.39503 61.454 6.15361C61.454 4.89078 60.9871 4.20586 60.0642 4.20586C59.1088 4.20586 58.6962 4.91218 58.6962 6.15361C58.707 7.38433 59.0979 7.95153 60.0642 7.95153ZM60.0751 2.52565C62.2466 2.52565 63.6907 3.94901 63.6907 6.1429C63.6907 8.28329 62.3118 9.66384 60.0642 9.66384C57.8167 9.66384 56.4378 8.29399 56.4378 6.16431C56.4378 3.93831 57.9144 2.52565 60.0751 2.52565ZM68.7069 2.57916V4.53762C68.5983 4.52691 68.4029 4.50551 68.2509 4.50551C67.2194 4.50551 66.5571 5.16903 66.5571 6.1215V9.4712H64.3096V2.70759H66.4811L66.5136 3.49953C66.8828 2.95373 67.404 2.54706 68.3486 2.54706C68.5223 2.55776 68.6417 2.56846 68.7069 2.57916Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
          <div className="contentContainer">
            <div className="upperSection">
              <Typography data-testid={`${dataTestId}-heading`} variant="h4" className="">
                {heading}
              </Typography>
              <Typography
                data-testid={`${dataTestId}-subheading`}
                variant="p2"
                className="subheading"
              >
                {subHeading}
              </Typography>
            </div>
            <div className={'bottomSection'}>
              <div className={clsx('priceContainer')}>
                <Typography data-testid={`${dataTestId}-cta`} variant="h4" className="priceText">
                  {price}
                </Typography>
                <ElementsSDK.Icon.ArrowRight />
              </div>
            </div>
          </div>
        </div>
      </CardLink>
    </div>
  );
};

export default Card;
